import React from 'react';
import DVRhealth from '@peoplenet/vi-components-ui/src/DVRhealth/container/DVRhealthPage';

const dvrHealth = () => {
  return (
    <div className="bodycontent">
      <DVRhealth />
    </div>
  );
};

export default dvrHealth;
